import { App } from './App';

class IPValidationAutoV2 {

    constructor() {
        this.Setting = {
            querySelector: '.ipvalidateenabled',
            formElementObj: document
        };
        this.SettingIntern = { ...this.Setting };

        window.setValidationError = this.setValidationError.bind(this);
    }

    init(ipvalidationAutoSettings) {
        this.SettingIntern = { ...this.Setting, ...ipvalidationAutoSettings };
        const elements = this.SettingIntern.formElementObj.querySelectorAll(this.SettingIntern.querySelector);
        const self = this;

        elements.forEach(function (el) {
            // Add blur event listener
            // Using function() so `this` refers to the element (el)
            el.addEventListener('blur', function (evnt) {
                if (self.IPValidate(this)) {
                    self.IPValidateFormat(this);
                }
            });

            // Add focus event listener
            el.addEventListener('focus', function (evnt) {
                setValidationOk(this);
            });

            // Add input event listener
            el.addEventListener('keydown', function (evnt) {
                self.IPValidateKeypress(evnt, this);
            });
        });
    }

    isHidden = (elm) => (elm.offsetParent === null);

    IPValidateElements(selectorString) {
        const elements = this.SettingIntern.formElementObj.querySelectorAll(selectorString);

        return IPValidateElementsObj(elements);
    }

    IPValidateElementsObj(elements) {
        elements.forEach((element) => {
            if (!this.IPValidate(element, true)) {
                return false;
            }
        });
        return true;
    }

    IPValidateElementsScrollToErr(selectorString) {
        let ok = true;
        let frst = null;

        const elements = this.SettingIntern.formElementObj.querySelectorAll(selectorString);

        elements.forEach((element) => {
            if (!this.IPValidate(element, true)) {
                if (ok) {
                    frst = element;
                }
                ok = false;
            }
        });

        if (!ok && frst) {
            this.scrollToElm(frst);
        }

        return ok;
    }

    IPValidateAll() {
        const elements = this.scopedElements();
        let firstElmWithError = null;

        elements.forEach((el) => {
            if (!this.IPValidate(el, true) && !firstElmWithError) {
                firstElmWithError = el;
            }
        });
        if (firstElmWithError) {
            console.warn('Validation failed, first failed element:', firstElmWithError, 'Value: ', firstElmWithError.value);
            this.scrollToElm(firstElmWithError);
            return false;
        }
        return true;
    }

    scopedElements() {
        return this.SettingIntern.formElementObj.querySelectorAll(this.SettingIntern.querySelector);
    }

    /**
     * @param {HTMLElement} elm - The element to scroll to.
     */
    scrollToElm(elm) {
        if (!elm) return;
        // No math required
        elm.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    IPValidateEnter = (evnt, ths) => setValidationOk(ths);

    IPValidateKeypress(evnt, ths) {
        const ipValidateObj = this.getIPValidateObj(ths);
        let prvnt = false;
        const keyCode = evnt.which || evnt.keyCode;
        const ctrlDown = evnt.ctrlKey;
        const key = evnt.key;
        const is0to9 = /^[0-9]$/.test(key);

        if (ctrlDown || keyCode === 8 || keyCode === 9 || keyCode === 13 || keyCode === 37 || keyCode === 39 || keyCode === 46 || keyCode === 47) {
            return;
        }
        const typeStr = (ipValidateObj.type || ths.type)?.toLowerCase();
        if (ipValidateObj.type == 'integer' || typeStr == 'cvrorpno') prvnt = !is0to9;
        if (typeStr == 'number') prvnt = (!is0to9 && key != ',' && key != '.');
        if (typeStr == 'date' || typeStr == 'dateorcpr') {
            prvnt = !(is0to9 || key == '-');
        }
        if (typeStr == 'dateorcprloose') {
            prvnt = !(is0to9 || key == '-' || key == '/' || key == '.');
        }
        if (prvnt) {
            evnt.preventDefault();
            return false;
        }
    }


    IPValidateFormat(element) {
        const ipValidateObj = this.getIPValidateObj(element);
        if (ipValidateObj.type == 'integer') {
            const v = this.getInputNumber(element).toLocaleString('da');
            element.value = v;
        }
    }

    IPValidate(element, doNotUseDefault) {
        const value = element.value;
        const ipValidateObj = this.getIPValidateObj(element);

        if (!value) {
            if (ipValidateObj.whenBlankDefaultTo && !doNotUseDefault) {
                element.value = ipValidateObj.whenBlankDefaultTo;
            } else {
                return ipValidateObj.required ? this.setValidationError(element, '', true) : setValidationOk(element);
            }
        }

        if (ipValidateObj.type) {
            const ipValidateObjtype = ipValidateObj.type?.toLowerCase();
            // Assuming all 'validate...' functions exist in the global scope
            if (ipValidateObjtype === 'isbn') return validateIBAN(element);
            if (ipValidateObjtype === 'swift') return validateSwift(element);
            if (ipValidateObjtype === 'kontonr') return validateKontoNr(element);
            if (ipValidateObjtype === 'onlyletters') return validateOnlyLetters(element);
            if (ipValidateObjtype === 'onlylettersdk') return validateOnlyDkLetters(element);
            if (ipValidateObjtype === 'onlylettersdkwhitespaceallowed') return validateOnlyDkLettersOneWhiteSpaceAllowed(element);
            if (ipValidateObjtype === 'cpr11') return modulus11Cpr(element);
            if (ipValidateObjtype === 'cpr') return validateCpr(element);
            if (ipValidateObjtype === 'cprpensionsplan2022') return validateCprPensionsplan2022(element);
            if (ipValidateObjtype === 'cvr') return validateCvr(element);
            if (ipValidateObjtype === 'dateorcpr') return validateCprOrBirthday(element);
            if (ipValidateObjtype === 'dateorcprloose') return validateCprOrBirthday(element);
            if (ipValidateObjtype === 'cvrorpno') return validateCvrOrPno(element);
        }

        if (element.type === 'email' || ipValidateObj.type === 'email') {
            return ipValidateObj.required ? validateEmailRequired(element) : validateEmail(element);
        }
        if (element.type === 'phone' || ipValidateObj.type === 'phone') {
            return ipValidateObj.required ? validateTelefonRequired(element) : validateTelefon(element);
        }

        if (element.type === 'date' || ipValidateObj.type === 'date') {
            return ipValidateObj.required ? validateDateRequired(element, ipValidateObj.min, ipValidateObj.max) : validateDate(element, ipValidateObj.min, ipValidateObj.max);
        }

        if (element.type === 'number' || ipValidateObj.type === 'integer' || ipValidateObj.type === 'number' || ipValidateObj.fixedFraction) {
            const num = this.getInputNumber(element);
            if (isNaN(num)) {
                return this.setValidationError(element);
            }

            if (!isNaN(ipValidateObj.min) && num < ipValidateObj.min) {
                if (ipValidateObj.onOutOfRange == 'useMinMax') {
                    element.value = ipValidateObj.min;
                } else {
                    return this.setValidationError(element);
                }
            }
            if (!isNaN(ipValidateObj.max) && num > ipValidateObj.max) {
                if (ipValidateObj.onOutOfRange == 'useMinMax') {
                    element.value = ipValidateObj.max;
                } else {
                    return this.setValidationError(element);
                }
            }
        }
        if (element.type === 'radio' || ipValidateObj.type === 'radio') {
            const name = element.name;
            const radioElms = [...document.querySelectorAll(`[name=${name}]`)];
            const hasCheckedVal = radioElms.some(radioElm => radioElm.checked);
            if (!hasCheckedVal) {
                return this.setValidationError(element);
            }
        }
        // fixedFraction should be a number indicating the amount of decimals.
        // Set this to 0 to not allow decimals at all.
        if (ipValidateObj.fixedFraction !== undefined) {
            const v = this.getInputNumber(element);
            element.value = v.toFixed(ipValidateObj.fixedFraction).replace(',', '').replace('.', ',');
            if (element.value == '') element.value = v.toFixed(ipValidateObj.fixedFraction);
        }

        setValidationOk(element);
        return true;
    }

    // --- Private Helper Methods ---

    getInputNumber(elm) {
        const u = elm.value.replace(/\./g, '').replace(/,/g, '.');
        const v = (elm.valueAsNumber && !isNaN(elm.valueAsNumber)) ? elm.valueAsNumber : Number(u);
        return v;
    }

    // replacing PlaceHolders in tmplString wiht matchng values form keyvalues
    PhReplace(tmplStr, keyvalues) {
        if (!tmplStr) return tmplStr;
        return tmplStr.replace(/(\{(\w+)\})/g, function (k1, k2, k3) { return (keyvalues[k3] != null) ? keyvalues[k3] : k1; });
    }

    // Getting the data-ipvalidate from the element - supposed to be in json format!
    getIPValidateObj(element) {
        const ipvalidateText = element.dataset.ipvalidate;
        let ipValidateObj = ipvalidateText || {};

        if (typeof (ipValidateObj) == 'string' && ipvalidateText) ipValidateObj = JSON.parse(ipvalidateText);

        if (element.hasAttribute('min')) ipValidateObj.min = parseInt(element.getAttribute('min'), 10);
        if (element.hasAttribute('max')) ipValidateObj.max = parseInt(element.getAttribute('max'), 10);
        ipValidateObj.required = ipValidateObj.required || element.hasAttribute('required');

        return ipValidateObj;
    }

    // Overriding setValidationError2 in IP.Validation.js (adding setValidationErrorPre(..))
    setValidationError(element, txt, useRequiredtext) {
        const elem = (element instanceof jQuery) ? element[0] : element;

        this.setValidationErrorPre(element, txt, useRequiredtext);
        const fu = elem.closest('div.fu');

        if (fu) {
            const errorDiv = fu.querySelector('div.error');
            if (errorDiv) {
                errorDiv.style.display = 'block';
            }
            fu.classList.add('error');
        }
        return false; // Return false for failed validation
    }

    // Will manage texts for the error message
    setValidationErrorPre(element, txt, useRequiredtext) {
        const elem = (element instanceof jQuery) ? element : $(element);

        const fuElm = elem.closest('div.fu');
        const msgElms = fuElm
            .find('div.msg')
            .filter((idx, msgElm) => $(msgElm).closest('div.fu').get(0).isSameNode(fuElm.get(0)));

        const msgdiv = msgElms.first();
        let defaultText = msgdiv.data('defaulttext');
        const txtInner = msgdiv.text();
        if (!defaultText && txtInner) {
            msgdiv.data('defaulttext', txtInner);
            defaultText = txtInner;
        }
        const tmpl = useRequiredtext ? elem.data('requirederrtmpl') : elem.data('formaterrtmpl');
        if (txt) {
            const textField = msgdiv.children().length ? msgdiv.children().get(0) : msgdiv;
            textField.text = txt;
        } else if (tmpl) {
            const ipValidateObj = getIPValidateObj(elem[0]);
            const t = function () {
                return PhReplace(tmpl, ipValidateObj);
            };
            msgdiv.text(t);
        } else if (defaultText) {
            const textField = msgdiv.children().length ? msgdiv.children().get(0) : msgdiv;
            textField.text = defaultText;
        }
    }
}


App.IPValidationAutoV2Class = IPValidationAutoV2;
export default IPValidationAutoV2;
